import INVENTORY_API_BASE_URL from "../../config/api";
import "./orderstatus.css";
import { useEffect, useState } from "react";
import Axios from "axios";
import Table from "react-bootstrap/Table";

function Orderstatus() {
  const [listOfShelf, setListOfShelf] = useState([]);
  const [totalBarcodes, setTotalBarcodes] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 1;
  const [data, setData] = useState([]);
  const [totalPurchasePrice, setTotalPurchasePrice] = useState(0);
  const [totalMrpValue, setTotalMrpValue] = useState(0);

  useEffect(() => {
    Axios.get(INVENTORY_API_BASE_URL + "/getOrder").then((response) => {
      setData(response.data);
    });
  }, []);

  useEffect(() => {
    Axios.get(INVENTORY_API_BASE_URL + "/getCreateshelf").then((response) => {
      setListOfShelf(response.data);

      const total = response.data.reduce(
        (sum, shelf) => sum + (shelf.barcodeData ? shelf.barcodeData.length : 0),
        0,
      );
      setTotalBarcodes(total);
    });
  }, []);

  useEffect(() => {
    let totalPurchase = 0;
    let totalMrp = 0;

    listOfShelf.forEach((shelf) => {
      if (shelf.barcodeData && shelf.barcodeData.length > 0) {
        shelf.barcodeData.forEach((barcode) => {
          const matchingItem = data
            .flatMap((order) => order.updatedQuantity || [])
            .find((item) => barcode.includes(item.batchid));

          let finalItem = matchingItem;

          if (!matchingItem) {
            const barcodePrefix = barcode.substring(0, 5);
            const matchingItems = data
              .flatMap((order) => order.updatedQuantity || [])
              .filter((item) => item.batchid?.startsWith(barcodePrefix));

            finalItem = matchingItems.sort((a, b) =>
              b.batchid.localeCompare(a.batchid),
            )[0];
          }

          if (finalItem?.purchasePrice) {
            totalPurchase += parseFloat(finalItem.purchasePrice);
          }

          if (finalItem?.mrp) {
            totalMrp += parseFloat(finalItem.mrp);
          }
        });
      }
    });

    setTotalPurchasePrice(totalPurchase);
    setTotalMrpValue(totalMrp);
  }, [data, listOfShelf]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = listOfShelf.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(listOfShelf.length / itemsPerPage);
  const pageNumbers = [...Array(totalPages).keys()].map((num) => num + 1);
  const totalSellingPrice = totalMrpValue * 0.41;
  const currentPageBarcodeCount = currentItems.reduce(
    (sum, shelf) => sum + (shelf.barcodeData?.length || 0),
    0,
  );

  return (
    <main className="orderstatus-page">
      <div className="orderstatus-content">
        <header className="orderstatus-hero">
          <div className="orderstatus-hero-copy">
            <span className="orderstatus-eyebrow">
              <span className="orderstatus-live-dot" aria-hidden="true" />
              INVENTORY / OPERATIONS
            </span>
            <h1>Order status</h1>
            <p>
              Review shelf stock by barcode, batch, SKU, and book details.
            </p>
          </div>
          <div className="orderstatus-hero-summary">
            <span className="orderstatus-hero-icon" aria-hidden="true">▤</span>
            <span>
              <small>Current shelf</small>
              <strong>
                {totalPages > 0 ? currentPage + " of " + totalPages : "No shelves"}
              </strong>
            </span>
          </div>
        </header>

        <section className="orderstatus-metrics" aria-label="Inventory totals">
          <article className="orderstatus-metric">
            <span className="orderstatus-metric-icon" aria-hidden="true">01</span>
            <div>
              <span>Total stock quantity</span>
              <strong>{totalBarcodes.toLocaleString()}</strong>
              <small>Barcodes across all shelves</small>
            </div>
          </article>
          <article className="orderstatus-metric">
            <span className="orderstatus-metric-icon orderstatus-metric-icon--green" aria-hidden="true">02</span>
            <div>
              <span>Total value</span>
              <strong>₹{totalSellingPrice.toFixed(2)}</strong>
              <small>Current stock value</small>
            </div>
          </article>
          <article className="orderstatus-metric">
            <span className="orderstatus-metric-icon orderstatus-metric-icon--violet" aria-hidden="true">03</span>
            <div>
              <span>Shelves tracked</span>
              <strong>{listOfShelf.length.toLocaleString()}</strong>
              <small>One shelf per page</small>
            </div>
          </article>
        </section>

        <section className="orderstatus-table-card" aria-labelledby="orderstatus-table-title">
          <div className="orderstatus-table-heading">
            <div>
              <span className="orderstatus-section-kicker">SHELF INVENTORY</span>
              <h2 id="orderstatus-table-title">Barcode details</h2>
              <p>Matched order details for each barcode on the current shelf.</p>
            </div>
            <span className="orderstatus-count">
              {currentPageBarcodeCount.toLocaleString()} barcodes on this page
            </span>
          </div>

          <div className="orderstatus-table-scroll">
            <Table className="orderstatus-table">
              <thead>
                <tr>
                  <th scope="col">Barcode</th>
                  <th scope="col">Batch ID</th>
                  <th scope="col">SKU</th>
                  <th scope="col">Title</th>
                  <th scope="col">Medium</th>
                  <th scope="col">Edition</th>
                  <th scope="col">Printing price</th>
                  <th scope="col">MRP</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((shelf, index) =>
                    shelf.barcodeData && shelf.barcodeData.length > 0 ? (
                      shelf.barcodeData.map((barcode, i) => {
                        const matchingItem = data
                          .flatMap((order) => order.updatedQuantity || [])
                          .find((item) => barcode.includes(item.batchid));

                        let finalItem = matchingItem;
                        if (!matchingItem) {
                          const barcodePrefix = barcode.substring(0, 5);
                          const matchingItems = data
                            .flatMap((order) => order.updatedQuantity || [])
                            .filter((item) =>
                              item.batchid?.startsWith(barcodePrefix),
                            );

                          finalItem = matchingItems.sort((a, b) =>
                            b.batchid.localeCompare(a.batchid),
                          )[0];
                        }

                        return (
                          <tr key={index + "-" + i}>
                            <td className="orderstatus-barcode">{barcode}</td>
                            <td>{finalItem ? finalItem.batchid : "No Match"}</td>
                            <td>{finalItem ? finalItem.sku || "N/A" : "No Match"}</td>
                            <td className="orderstatus-title">
                              {finalItem ? finalItem.title || "N/A" : "No Match"}
                            </td>
                            <td>{finalItem ? finalItem.Medium || "N/A" : "No Match"}</td>
                            <td>{finalItem ? finalItem.edition || "N/A" : "No Match"}</td>
                            <td className="orderstatus-price">
                              {finalItem ? finalItem.purchasePrice || "N/A" : "No Match"}
                            </td>
                            <td className="orderstatus-price">
                              {finalItem ? finalItem.mrp || "N/A" : "No Match"}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr key={index}>
                        <td className="orderstatus-empty-row" colSpan="8">
                          <strong>No barcodes on this shelf</strong>
                          <span>This shelf does not have any stock records to display.</span>
                        </td>
                      </tr>
                    ),
                  )
                ) : (
                  <tr>
                    <td className="orderstatus-empty-row" colSpan="8">
                      <strong>No shelf records found</strong>
                      <span>There are no shelves available for this view.</span>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <nav className="orderstatus-pagination" aria-label="Shelf pages">
            <button
              type="button"
              className="orderstatus-page-arrow"
              onClick={() => paginate(Math.max(currentPage - 1, 1))}
              disabled={currentPage === 1 || totalPages === 0}
              aria-label="Previous shelf"
            >
              ‹
            </button>
            <div className="orderstatus-page-list">
              {pageNumbers.map((number) => (
                <button
                  type="button"
                  key={number}
                  onClick={() => paginate(number)}
                  className={number === currentPage ? "active" : ""}
                  aria-current={number === currentPage ? "page" : undefined}
                >
                  {number}
                </button>
              ))}
            </div>
            <span className="orderstatus-page-status">
              Page <strong>{totalPages > 0 ? currentPage : 0}</strong> of{" "}
              <strong>{totalPages}</strong>
            </span>
            <button
              type="button"
              className="orderstatus-page-arrow"
              onClick={() => paginate(Math.min(currentPage + 1, totalPages))}
              disabled={currentPage === totalPages || totalPages === 0}
              aria-label="Next shelf"
            >
              ›
            </button>
          </nav>
        </section>
      </div>
    </main>
  );
}

export default Orderstatus;
